import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=bc5327e2"
import script from "./tab3.vue?vue&type=script&lang=js"
export * from "./tab3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports